import { useState } from "react";
import { useOrders } from "@/lib/OrdersContext";
import { COLUMNS, eur } from "@/lib/workshop";
import { OrderCard } from "@/components/OrderCard";

const Column = ({ col, orders }) => {
  const { moveOrder } = useOrders();
  const [over, setOver] = useState(false);
  const total = orders.reduce((s, o) => s + o.importe, 0);
  return (
    <section
      data-testid={`kanban-column-${col.id}`}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); moveOrder(e.dataTransfer.getData("text/plain"), col.id); }}
      className={`flex w-[85vw] max-w-[320px] shrink-0 snap-start flex-col rounded-2xl border p-3 transition-colors duration-200 md:w-auto md:max-w-none md:min-w-0 ${over ? "border-[var(--gold)]/50 bg-[var(--gold-soft)]" : "border-white/5 bg-[#0e0e11]"}`}
    >
      <header className="mb-3 flex items-center justify-between px-1">
        <div className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full" style={{ background: col.accent }} />
          <h3 className="font-display text-sm font-semibold">{col.label}</h3>
          <span data-testid={`kanban-column-count-${col.id}`} className="rounded-md bg-white/5 px-1.5 text-xs text-zinc-400">{orders.length}</span>
        </div>
        <span className="text-[11px] text-zinc-500">{eur(total)}</span>
      </header>
      <div className="scroll-thin flex min-h-[200px] flex-1 flex-col gap-3 overflow-y-auto">
        {orders.map((o) => <OrderCard key={o.id} order={o} />)}
        {orders.length === 0 && (
          <div className="flex flex-1 items-center justify-center rounded-xl border border-dashed border-white/10 text-xs text-zinc-600">
            Arrastra órdenes aquí
          </div>
        )}
      </div>
    </section>
  );
};

export const KanbanBoard = () => {
  const { filtered } = useOrders();
  return (
    <div data-testid="kanban-board" className="scroll-thin -mx-4 flex snap-x snap-mandatory scroll-px-4 gap-4 overflow-x-auto px-4 pb-4 md:mx-0 md:grid md:grid-cols-2 md:overflow-visible md:px-0 xl:grid-cols-4">
      {COLUMNS.map((c) => <Column key={c.id} col={c} orders={filtered.filter((o) => o.estado === c.id)} />)}
    </div>
  );
};
